export default function MoneyBackGuarantee() {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-orange-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            30 Day Money Back Guarantee
          </h2>
          <p className="text-2xl text-gray-700 mb-8">
            No Questions Asked
          </p>

          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            If you are not 100% satisfied, we are not satisfied. That's why we'll happily give you your money back. Zero questions asked.
          </p>
        </div>
      </div>
    </section>
  );
}
